export default "__VITE_ASSET__f24273ce__"